import {
  FAILED_SET_OFFERS,
  SET_ALL_OFFERS,
  SET_CROSS_SELLING_OFFERS,
  // eslint-disable-next-line prettier/prettier
  SET_HOME_OFFERS, SET_OFFER_DETAILS, SET_SWITCH_OFFER
} from './actionsTypes'

const initialState = {
  homeOffers: null,
  allOffers: null,
  crossSellingOffers: null,
  errorMsg: null,
  offerDetails: null,
  isUserChoseFirstSwitchOption: false,
}

const offersData = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_HOME_OFFERS:
      return {
        ...state,
        homeOffers: payload,
      }

    case SET_ALL_OFFERS:
      return {
        ...state,
        allOffers: payload,
      }
    case SET_OFFER_DETAILS:
      return {
        ...state,
        offerDetails: payload,
      }
    case SET_CROSS_SELLING_OFFERS:
      return {
        ...state,
        crossSellingOffers: payload,
      }
    case FAILED_SET_OFFERS:
      return {
        ...state,
        errorMsg: payload,
      }
    case SET_SWITCH_OFFER:
      return {
        ...state,
        isUserChoseFirstSwitchOption: payload,
      }
    default:
      return state
  }
}

export default offersData
